const { upgradeArray } = require('../utils')

const REQUISITE_TYPES = upgradeArray([ 'business', 'personal' ])
const BUSINESS_TYPES = upgradeArray([ 'organization', 'individual' ])

module.exports = {
  REQUISITE_TYPES,
  BUSINESS_TYPES
}
